import {createContext} from 'react';
import {AuxiliaryDataCacheContextType} from './types';

// Create Context
export const AuxiliaryDataCacheContext = createContext<AuxiliaryDataCacheContextType>(
  {} as AuxiliaryDataCacheContextType
);
